@use '~/theme/theme' as *;

.trigger {
  flex-shrink: 0;
  margin-left: auto;
  color: color(grey-600);
}

.content {
  padding: spacing(2);
}
